module.exports = __webpack_public_path__ + "kobologo_symbol.svg";